import React from 'react';
import { Box } from '@mui/material';
import { launchColors } from '../launchTheme';

const ListSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => (
  <Box aria-hidden>
    {Array.from({ length: rows }, (_item, index) => (
      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1.5, height: 40, borderTop: `1px solid ${launchColors.rowDivider}` }}>
        <Box sx={{ width: 56, height: 12, borderRadius: '4px', bgcolor: launchColors.neutralBg }} />
        <Box sx={{ flex: 1, height: 12, borderRadius: '4px', bgcolor: launchColors.section }} />
        <Box sx={{ width: 48, height: 12, borderRadius: '4px', bgcolor: launchColors.neutralBg }} />
      </Box>
    ))}
  </Box>
);

export default ListSkeleton;
